import React, { useState } from "react";
import { IconButton, Tooltip, Fade, useTheme } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

const CopyTextButton = ({
  text,
  tooltipText = "Copy text",
  copiedTooltipText = "Copied!",
  sx = {},
  size = "small",
  onCopy,
  icon: Icon,
}) => {
  const theme = useTheme();

  const [isCopied, setIsCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    if (onCopy) onCopy(text);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <Tooltip
      title={isCopied ? copiedTooltipText : tooltipText}
      open={isCopied || isHovered}
      placement='top'
      arrow
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 100 }}
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "0.75rem",
            fontWeight: 500,
            backgroundColor: isCopied ? "success.main" : "grey.800",
            color: "common.white",
            "& .MuiTooltip-arrow": {
              color: isCopied ? "success.main" : "grey.800",
            },
          },
        },
      }}
    >
      <IconButton
        size={size}
        onClick={handleCopy}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={isCopied}
        sx={{
          opacity: 0.6,
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            opacity: 1,
            color: theme.palette.primary.main,
            transform: "scale(1.1)",
          },
          ...sx,
        }}
      >
        <Fade in={!isCopied} timeout={150}>
          {Icon ? (
            <Icon
              fontSize={size}
              sx={{
                position: isCopied ? "absolute" : "static",
                opacity: isCopied ? 0 : 1,
              }}
            />
          ) : (
            <ContentCopyIcon
              fontSize={size}
              sx={{
                position: isCopied ? "absolute" : "static",
                opacity: isCopied ? 0 : 1,
              }}
            />
          )}
        </Fade>
        <Fade in={isCopied} timeout={150}>
          <CheckIcon
            fontSize={size}
            sx={{
              position: isCopied ? "static" : "absolute",
              opacity: isCopied ? 1 : 0,
            }}
          />
        </Fade>
      </IconButton>
    </Tooltip>
  );
};

export default CopyTextButton;
